import { useTranslation } from 'react-i18next';
import './AllSubDepartments.css'
import { useEffect, useMemo, useState, useRef } from 'react';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductionCompany } from '../../redux/actions/ProductionCompanyAction';
import { motion } from 'framer-motion';
import { useDarkMode } from '../../App';

import { fetchSubcategories, fetchSubcategoriesProducts } from '../../redux/actions/CategoriesAction';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { fetchFilteredProducts } from '../../redux/actions/filterAction';
import { setCompany, setPriceRange, setSort, setSubcategory, setLengthRange, setWeightRange, setSearchFilter } from '../../redux/slices/filterSlice';
import { clearFilteredProducts } from '../../redux/slices/productSlice';
import { addToCart, fetchCartItems } from '../../redux/actions/cartAction';
import { toast } from 'react-toastify';

function AllSubDepartments() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const { t, i18n } = useTranslation("global")
    const { id, sub } = useParams();
    const dispatch = useDispatch();
    const { isDarkMode } = useDarkMode();

    const {
        subcategories,
        categories

    } = useSelector((state) => state.categories);


    useEffect(() => {
        if (sub) {
            dispatch(fetchSubcategories({
                categoryId: sub,
                lang: i18n.language
            }));
        }
    }, [dispatch, sub, i18n.language]);

    const currentSubcategories = useMemo(() => {
        const arr = subcategories[id];
        if (Array.isArray(arr)) return arr;
        if (arr && Array.isArray(arr.data)) return arr.data;
        return [];
    }, [subcategories, id]);
    const selectedSubcategory = useMemo(() =>
        currentSubcategories.find(subcategory => subcategory.id == parseInt(sub)),
        [currentSubcategories, id]
    );
    return <>
                        <div className={`breadcrumb-box text-center py-5 mb-4 rounded ${isDarkMode ? 'dark-mode' : ''}`} style={{ 
                            background: isDarkMode ? 'var(--color-card)' : "#000c3d0D" 
                        }}>
            <h4 className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
                {t('departments.store')}
            </h4>
            <p className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                {selectedSubcategory?.name} / {t('departments.products')}
            </p>
        </div>  <DepartmentsDetails />

    </>
}
function DepartmentsDetails() {
    const priceTimeout = useRef();
    const { t, i18n } = useTranslation("global")
    const { id, sub } = useParams();
    const dispatch = useDispatch();
    const { data: companies } = useSelector((state) => state.productionCompany);
    const { subcategoryProducts } = useSelector((state) => state.categories);
    const navigate = useNavigate();
    const location = useLocation();
    const { isDarkMode } = useDarkMode();
  
  

    useEffect(() => {
        dispatch(fetchProductionCompany(i18n.language));
    }, [dispatch, i18n.language]);

    const {
        subcategories,
        categories

    } = useSelector((state) => state.categories);


    useEffect(() => {
        if (id && sub) {
            dispatch(fetchSubcategories({
                categoryId: id,
                lang: i18n.language
            }));
        }
    }, [dispatch, id, i18n.language]);

    const currentSubcategories = useMemo(() =>
        subcategories[id] || [],
        [subcategories, sub]
    );
    const selectedSubcategory = useMemo(() =>
        currentSubcategories?.data?.find(subcategory => subcategory.id === parseInt(sub)),
        [currentSubcategories, id]
    );
    const [useFilteredData, setUseFilteredData] = useState(false);
    const filters = useSelector((state) => state.filters);

    const {
        byCategory,
        pagination,
        currentCategory,
    } = useSelector((state) => state.categories.subcategoryProducts);
    useEffect(() => {
        if (useFilteredData) {
            dispatch(fetchFilteredProducts({ ...filters, lang: i18n.language }));
        }
    }, [dispatch, filters, useFilteredData, i18n.language]);
    const isLoading = useSelector((state) => state.categories.isLoadingProducts);
    const error = useSelector((state) => state.categories.error);
    useEffect(() => {
        if (sub) {
            dispatch(fetchSubcategoriesProducts({ sub, lang: i18n.language, page: 1 }));
            // Also sync the subcategory in filters slice
            dispatch(setSubcategory(sub));
        }
    }, [sub, dispatch, i18n.language]);


    const handlePageChange = (page) => {
        dispatch(fetchSubcategoriesProducts({ sub, lang: i18n.language, page }));
    };



    const totalPages = pagination?.last_page || 1;
    const currentPage = pagination?.current_page || 1;


    const productsData = useSelector((state) => state.products2.data);
    // راقب الداتا نفسها
    // //console.log("productsData", productsData);


    const handleSortChange = (value) => {
        dispatch(setSort({ sort: value, subcategory: sub }));
        dispatch(clearFilteredProducts());
        setUseFilteredData(true);
        window.scrollTo(0, 0);
    };
    const handleSubcategoryChange = (subcategoryId) => {
        if (filters.subcategory === subcategoryId) {
            dispatch(setSubcategory(null));
            dispatch(clearFilteredProducts());
            let filtersCopy1 = { ...getActiveFilters(), subcategory: null };
            filtersCopy1.subcategory = sub ?? 'all';
            // //console.log("sub from useParams", sub);
            // //console.log("filtersCopy", filtersCopy1);
            dispatch(fetchFilteredProducts(filtersCopy1));
            setUseFilteredData(true);
            window.scrollTo(0, 0);
        } else {
            dispatch(setSubcategory(subcategoryId));
            dispatch(clearFilteredProducts());
            let filtersCopy2 = { ...getActiveFilters(), subcategory: subcategoryId };
            // هنا subcategoryId هو المحدد فلا داعي لإضافة sub
            // //console.log("sub from useParams", sub);
            // //console.log("filtersCopy", filtersCopy2);
            dispatch(fetchFilteredProducts(filtersCopy2));
            setUseFilteredData(true);
            window.scrollTo(0, 0);
        }
    };





    useEffect(() => {
        dispatch(fetchProductionCompany(i18n.language));
    }, [dispatch, i18n.language]);
    const [openCategory, setOpenCategory] = useState(null);
    // دالة فتح التصنيف مع جلب التصنيفات الفرعية إذا لم تكن محملة
    const handleCategoryToggle = (categoryId) => {
        setOpenCategory(prev => prev === categoryId ? null : categoryId);
        if (!subcategories[categoryId]) {
            dispatch(fetchSubcategories({ categoryId, lang: i18n.language }));
        }
    };
    const [fromValue, setFromValue] = useState("");
    const [toValue, setToValue] = useState("");
    const [fromLength, setFromLength] = useState("");
    const [toLength, setToLength] = useState("");
    const [priceFrom, setPriceFrom] = useState("");
    const [priceTo, setPriceTo] = useState("");

    // حالة البحث بالاسم
    const [search, setSearch] = useState("");

    const currentData = useFilteredData
        ? { data: productsData }
        : (byCategory?.data?.length > 0 ? byCategory : { data: [] });
    const productsArray = Array.isArray(currentData.data) ? currentData.data : currentData.data?.data || [];




    useEffect(() => {
        if (search && search.length > 1) {
            dispatch(setSearchFilter({ search: search, subcategory: sub }));
            dispatch(clearFilteredProducts());
            setUseFilteredData(true);
        } else if (search === "") {
            setUseFilteredData(false);
            const params = new URLSearchParams(location.search);
            if (params.has('search')) {
                params.delete('search');
                navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
            }
        }
    }, [search, dispatch, location, navigate, sub]);

    
    if (isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">جاري التحميل...</span>
            </div>
        </div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    function areAllFiltersEmpty() {
        return !priceFrom && !priceTo && !fromValue && !toValue && !fromLength && !toLength && (!search || search.length <= 1);
    }
    function getActiveFilters() {
        return {
            lang: i18n.language,
            ...(priceFrom && { price_min: priceFrom }),
            ...(priceTo && { price_max: priceTo }),
            ...(fromValue && { weight_min: fromValue }),
            ...(toValue && { weight_max: toValue }),
            ...(fromLength && { length_min: fromLength }),
            ...(toLength && { length_max: toLength }),
            ...(search && search.length > 1 && { search: search }),
            ...(filters.sort_by && { sort_by: filters.sort_by }),
            // لا تضف subcategory هنا
        };
    }
    const handleApplyPrice = () => {
        if (areAllFiltersEmpty()) {
            setUseFilteredData(false);
            dispatch(setPriceRange({ min: '', max: '', subcategory: sub }));
            dispatch(fetchSubcategoriesProducts({ sub, lang: i18n.language, page: 1 }));
            window.scrollTo(0, 0);
        } else {
            dispatch(setPriceRange({ min: priceFrom, max: priceTo, subcategory: sub }));
            dispatch(clearFilteredProducts());
            setUseFilteredData(true);
            window.scrollTo(0, 0);
        }
    };
    const handleApplyWeight = () => {
        if (areAllFiltersEmpty()) {
            setUseFilteredData(false);
            dispatch(setWeightRange({ min: '', max: '', subcategory: sub }));
            dispatch(fetchSubcategoriesProducts({ sub, lang: i18n.language, page: 1 }));
            window.scrollTo(0, 0);
        } else {
            dispatch(setWeightRange({ min: fromValue, max: toValue, subcategory: sub }));
            dispatch(clearFilteredProducts());
            setUseFilteredData(true);
            window.scrollTo(0, 0);
        }
    };
    const handleApplyLength = () => {
        if (areAllFiltersEmpty()) {
            setUseFilteredData(false);
            dispatch(setLengthRange({ min: '', max: '', subcategory: sub }));
            dispatch(fetchSubcategoriesProducts({ sub, lang: i18n.language, page: 1 }));
            window.scrollTo(0, 0);
        } else {
            dispatch(setLengthRange({ min: fromLength, max: toLength, subcategory: sub }));
            dispatch(clearFilteredProducts());
            setUseFilteredData(true);
            window.scrollTo(0, 0);
        }
    };

    const handleCompanyClick = (companyId) => {
        dispatch(setCompany({ company: companyId, subcategory: sub }));
        dispatch(clearFilteredProducts());
        setUseFilteredData(true);
        window.scrollTo(0, 0);
    };

    // منطق تحديد إذا كان هناك فلترة نشطة
    const isFiltering = useFilteredData || search?.length > 1 || priceFrom || priceTo || fromValue || toValue || fromLength || toLength || selectedSubcategory || filters?.company || filters?.sort_by;



    return <section className='departments-section py-5'>
        <div className="container">

            <div className="row">
                {/* السايد بار يظهر دائمًا */}
                <div className="col-lg-3 col-md-12 filters-parent">
                    <div className={`sidebar mb-5 p-4 rounded-4 shadow-sm ${isDarkMode ? 'dark-mode' : ''}`} style={{ 
                        background: isDarkMode 
                            ? "var(--color-card)" 
                            : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                        border: isDarkMode 
                            ? "1px solid var(--color-border)" 
                            : "1px solid rgba(0,12,61,0.08)",
                        backdropFilter: "blur(10px)"
                    }}>
                        {/* Search Section */}
                        <div className="mb-4">
                            <h6 className="fw-bold mb-3" style={{ color: isDarkMode ? 'var(--color-text)' : '#000c3d' }}>
                                <i className="fas fa-search me-2"></i>
                                {t('departments.search')}
                            </h6>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className={`form-control form-control-sm border-0 ${isDarkMode ? 'dark-mode' : ''}`}
                                    placeholder={t('departments.search')}
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    style={{
                                        background: isDarkMode ? 'var(--color-input)' : 'rgba(255,255,255,0.8)',
                                        color: isDarkMode ? 'var(--color-text)' : undefined,
                                        borderRadius: '25px 0 0 25px',
                                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                />
                                <span className="input-group-text border-0" style={{
                                    background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                                    color: 'white',
                                    borderRadius: '0 25px 25px 0',
                                    cursor: 'pointer'
                                }}>
                                    <i className="bi bi-search"></i>
                                </span>
                            </div>
                        </div>

                        {/* Sort Section */}
                        <div className="mb-4">
                            <h6 className="fw-bold mb-3" style={{ color: isDarkMode ? 'var(--color-text)' : '#000c3d' }}>
                                <i className="fas fa-sort me-2"></i>
                                {t('departments.sortBy')}
                            </h6>
                            <div className="d-flex flex-column gap-2">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="sort"
                                        id="sort1"
                                        checked={filters.sort_by === 'asc'}
                                        onChange={() => handleSortChange('asc')}
                                        style={{ accentColor: '#000c3d' }}
                                    />
                                    <label className="form-check-label small fw-medium" htmlFor="sort1" style={{ 
                                        color: isDarkMode ? 'var(--color-text)' : '#495057' 
                                    }}>
                                        {t('departments.priceLowToHigh')}
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="sort"
                                        id="sort2"
                                        checked={filters.sort_by === 'desc'}
                                        onChange={() => handleSortChange('desc')}
                                        style={{ accentColor: '#000c3d' }}
                                    />
                                    <label className="form-check-label small fw-medium" htmlFor="sort2" style={{ 
                                        color: isDarkMode ? 'var(--color-text)' : '#495057' 
                                    }}>
                                        {t('departments.priceHighToLow')}
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Products Count */}
                        <div className="text-center p-3 rounded-3" style={{ 
                            background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                            color: 'white'
                        }}>
                            <h6 className="mb-1 fw-bold">{productsArray.length}</h6>
                            <small className="opacity-75">{t('departments.products')}</small>
                        </div>
                    </div>
                </div>
                <div className="col-lg-9 col-md-12 departments-parent">
                    {/* Header Section */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h5 className="fw-bold mb-1" style={{ color: isDarkMode ? 'var(--color-text)' : '#000c3d' }}>
                                {selectedSubcategory?.name || t('departments.products')}
                            </h5>
                            <p className="text-muted mb-0" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                                {productsArray.length} {t('departments.products')} {t('departments.available')}
                            </p>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                            <div className="text-muted small" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                                <i className="fas fa-filter me-1"></i>
                                {t('departments.filtered')}
                            </div>
                        </div>
                    </div>

                    <motion.div 
                        className="row g-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {productsArray.length > 0 ? (
                            productsArray.map((product, index) => (
                                <motion.div 
                                    className="col-lg-4 col-md-6" 
                                    key={product.id}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    whileHover={{ 
                                        y: -10, 
                                        scale: 1.02,
                                        transition: { duration: 0.3 } 
                                    }}
                                >
                                    <motion.div
                                        className={`product-card h-100 position-relative ${isDarkMode ? 'dark-mode' : ''}`}
                                        style={{
                                            background: isDarkMode 
                                                ? 'var(--color-card)' 
                                                : 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                                            borderRadius: '20px',
                                            overflow: 'hidden',
                                            boxShadow: isDarkMode 
                                                ? '0 8px 25px rgba(0,0,0,0.3), 0 3px 10px rgba(0,0,0,0.2)' 
                                                : '0 8px 25px rgba(0,0,0,0.08), 0 3px 10px rgba(0,0,0,0.04)',
                                            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                            cursor: 'pointer',
                                            border: isDarkMode 
                                                ? '1px solid var(--color-border)' 
                                                : '1px solid rgba(0,12,61,0.08)',
                                            position: 'relative'
                                        }}
                                        onClick={() => navigate(`/productDetails/${product.id}`)}
                                        whileHover={{
                                            y: -8,
                                            scale: 1.02,
                                            boxShadow: '0 15px 35px rgba(0,0,0,0.15), 0 5px 15px rgba(0,0,0,0.08)',
                                            transition: { duration: 0.3 }
                                        }}
                                    >
                                        {/* Product Image Section */}
                                        <div className="position-relative" style={{ height: '200px', overflow: 'hidden' }}>
                                            <Swiper
                                                modules={[Autoplay, Pagination]}
                                                spaceBetween={0}
                                                slidesPerView={1}
                                                pagination={{ 
                                                    clickable: true,
                                                    bulletClass: 'swiper-pagination-bullet-custom',
                                                    bulletActiveClass: 'swiper-pagination-bullet-active-custom'
                                                }}
                                                autoplay={{ delay: 4000, disableOnInteraction: false }}
                                                style={{ width: '100%', height: '100%' }}
                                                className="product-swiper"
                                            >
                                                {Array.isArray(product.images) && product.images.map((img, idx) => (
                                                    <SwiperSlide key={idx}>
                                                        <img 
                                                            src={img} 
                                                            className="w-100 h-100" 
                                                            alt="Product" 
                                                            style={{ 
                                                                objectFit: 'cover',
                                                                transition: 'transform 0.4s ease'
                                                            }} 
                                                        />
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                            
                                            {/* Status Badge */}
                                            <div className="position-absolute top-2 start-2">
                                                <span className="badge" style={{
                                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                                    color: 'white',
                                                    fontSize: '0.7rem',
                                                    fontWeight: '600',
                                                    padding: '4px 8px',
                                                    borderRadius: '12px'
                                                }}>
                                                    {product.status || 'Available'}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Product Content */}
                                        <div className="p-3 text-center" style={{ 
                                            background: isDarkMode 
                                                ? 'var(--color-card)' 
                                                : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                            position: 'relative'
                                        }}>
                                            {/* Product Name */}
                                            <h6 
                                                className="product-title fw-bold mb-2" 
                                                style={{ 
                                                    color: isDarkMode ? 'var(--color-text)' : '#000c3d',
                                                    fontSize: '1rem',
                                                    lineHeight: '1.3',
                                                    minHeight: '2.6rem',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {product.name}
                                            </h6>
                                            {product.code && (
                                                <div className="d-flex align-items-center justify-content-center gap-1 mb-1" style={{ fontSize: '0.85rem' }}>
                                                    <span style={{ color: isDarkMode ? 'var(--color-muted)' : '#6c757d' }}>{t('product.code')}:</span>
                                                    <span style={{ color: isDarkMode ? 'var(--color-text)' : '#212529', fontFamily: 'monospace' }}>{product.code}</span>
                                                </div>
                                            )}
                                            
                                            {/* Company */}
                                            <p className="text-muted small mb-2" style={{ 
                                                fontSize: '0.8rem',
                                                color: isDarkMode ? 'var(--color-muted)' : undefined
                                            }}>
                                                {product.company}
                                            </p>
                                            
                                            {/* Price */}
                                            <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
                                                {(product.offer_percent > 0 || (product.price > product.final_price)) ? (
                                                    <>
                                                        <span style={{ 
                                                            textDecoration: 'line-through',
                                                            color: isDarkMode ? 'var(--color-muted)' : '#999',
                                                            fontSize: '0.9rem'
                                                        }}>
                                                            {product.price}
                                                        </span>
                                                        <span className="fw-bold" style={{ 
                                                            color: isDarkMode ? 'var(--color-text)' : '#000c3d',
                                                            fontSize: '1.2rem'
                                                        }}>
                                                            {product.final_price}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span className="fw-bold" style={{ 
                                                        color: isDarkMode ? 'var(--color-text)' : '#000c3d',
                                                        fontSize: '1.2rem'
                                                    }}>
                                                        {product.price}
                                                    </span>
                                                )}
                                                <span className="text-muted small" style={{ 
                                                    color: isDarkMode ? 'var(--color-muted)' : undefined
                                                }}>جنيه</span>
                                            </div>
                                            
                                            {/* Action Buttons */}
                                            <div className="d-flex justify-content-center gap-2">
                                                <motion.button
                                                    className="btn btn-sm d-flex align-items-center justify-content-center"
                                                    style={{
                                                        background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '20px',
                                                        padding: '8px 16px',
                                                        fontSize: '0.8rem',
                                                        fontWeight: '600',
                                                        minWidth: '80px'
                                                    }}
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        navigate(`/productDetails/${product.id}`);
                                                    }}
                                                    whileHover={{ 
                                                        scale: 1.05,
                                                        boxShadow: '0 4px 15px rgba(0,12,61,0.3)',
                                                        transition: { duration: 0.2 }
                                                    }}
                                                    whileTap={{ scale: 0.95 }}
                                                >
                                                    <i className="uil uil-eye me-1" style={{ fontSize: '0.9rem' }}></i>
                                                    {t('departments.view')}
                                                </motion.button>
                                                
                                                <motion.button
                                                    className="btn btn-sm d-flex align-items-center justify-content-center"
                                                    style={{
                                                        background: 'linear-gradient(135deg, #ff3e3e 0%, #ff1a1a 100%)',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '20px',
                                                        padding: '8px 16px',
                                                        fontSize: '0.8rem',
                                                        fontWeight: '600',
                                                        minWidth: '80px'
                                                    }}
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        dispatch(addToCart({ 
                                                            product_id: product.id, 
                                                            qty: product.count || 1, 
                                                            language: i18n.language 
                                                        })).unwrap()
                                                        .then(() => {
                                                            toast.success(t('cart.addedSuccessfully'));
                                                            dispatch(fetchCartItems(i18n.language));
                                                        })
                                                        .catch((err) => toast(err.message || t('cart.addError')));
                                                    }}
                                                    whileHover={{ 
                                                        scale: 1.05,
                                                        boxShadow: '0 4px 15px rgba(255, 62, 62, 0.3)',
                                                        transition: { duration: 0.2 }
                                                    }}
                                                    whileTap={{ scale: 0.95 }}
                                                >
                                                    <i className="fas fa-cart-plus me-1" style={{ fontSize: '0.9rem' }}></i>
                                                    {t('home.addToCart')}
                                                </motion.button>
                                            </div>
                                        </div>

                                    </motion.div>
                                </motion.div>
                            ))
                        ) : (
                            <motion.div 
                                className="col-12 text-center"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6 }}
                            >
                                <div 
                                    className={`empty-state rounded-4 p-5 mx-auto ${isDarkMode ? 'dark-mode' : ''}`}
                                    style={{
                                        background: isDarkMode 
                                            ? 'var(--color-card)' 
                                            : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                        border: isDarkMode 
                                            ? '1px solid var(--color-border)' 
                                            : '1px solid rgba(0,12,61,0.08)',
                                        boxShadow: isDarkMode 
                                            ? '0 10px 30px rgba(0,0,0,0.3)' 
                                            : '0 10px 30px rgba(0,0,0,0.05)',
                                        maxWidth: '500px'
                                    }}
                                >
                                    <div className="mb-4">
                                        <i className="fas fa-box-open text-muted" style={{ 
                                            fontSize: '4rem', 
                                            color: isDarkMode ? 'var(--color-muted)' : '#6c757d' 
                                        }}></i>
                                    </div>
                                    <h5 className="fw-bold mb-3" style={{ 
                                        color: isDarkMode ? 'var(--color-text)' : '#000c3d', 
                                        fontSize: '1.5rem' 
                                    }}>
                                        {t('departments.noProducts', 'لا توجد منتجات متاحة')}
                                    </h5>
                                    <p className="text-muted mb-4" style={{ 
                                        fontSize: '1rem',
                                        color: isDarkMode ? 'var(--color-muted)' : undefined
                                    }}>
                                        {t('departments.tryDifferentFilters', 'جرب فلتر مختلف أو ابحث عن شيء آخر')}
                                    </p>
                                    <button 
                                        className="btn btn-primary rounded-pill px-4 py-2"
                                        style={{
                                            background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                                            border: 'none',
                                            fontWeight: '600'
                                        }}
                                        onClick={() => {
                                            setSearch('');
                                            setUseFilteredData(false);
                                        }}
                                    >
                                        <i className="fas fa-refresh me-2"></i>
                                        {t('departments.resetFilters', 'إعادة تعيين الفلاتر')}
                                    </button>
                                </div>
                            </motion.div>
                        )}
                    </motion.div>

                    {productsArray.length > 0 && (
                        <motion.div 
                            className="pagination-container mt-5"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div 
                                className={`d-flex justify-content-center align-items-center gap-2 p-4 rounded-4 ${isDarkMode ? 'dark-mode' : ''}`}
                                style={{
                                    background: isDarkMode 
                                        ? 'var(--color-card)' 
                                        : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                    border: isDarkMode 
                                        ? '1px solid var(--color-border)' 
                                        : '1px solid rgba(0,12,61,0.08)',
                                    boxShadow: isDarkMode 
                                        ? '0 8px 25px rgba(0,0,0,0.3)' 
                                        : '0 8px 25px rgba(0,0,0,0.08)',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                {currentPage > 1 && (
                                    <motion.button
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        className="btn btn-outline-primary rounded-pill px-4 py-2"
                                        style={{
                                            background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                                            color: 'white',
                                            border: 'none',
                                            fontWeight: '600'
                                        }}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <i className="fas fa-chevron-left me-2"></i>
                                        {t('departments.previous')}
                                    </motion.button>
                                )}

                                <div className="d-flex gap-2">
                                    {[...Array(totalPages)].map((_, index) => {
                                        const pageNumber = index + 1;
                                        if (
                                            pageNumber === 1 ||
                                            pageNumber === totalPages ||
                                            (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                                        ) {
                                            return (
                                                <motion.button
                                                    key={index}
                                                    className={`btn rounded-circle ${pageNumber === currentPage
                                                        ? "btn-primary"
                                                        : "btn-outline-primary"
                                                        }`}
                                                    style={{
                                                        width: '45px',
                                                        height: '45px',
                                                        fontWeight: '600',
                                                        ...(pageNumber === currentPage ? {
                                                            background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                                                            border: 'none',
                                                            color: 'white'
                                                        } : {
                                                            background: isDarkMode ? 'var(--color-card)' : 'transparent',
                                                            border: isDarkMode ? '2px solid var(--color-text)' : '2px solid #000c3d',
                                                            color: isDarkMode ? 'var(--color-text)' : '#000c3d'
                                                        })
                                                    }}
                                                    onClick={() => handlePageChange(pageNumber)}
                                                    whileHover={{ scale: 1.1 }}
                                                    whileTap={{ scale: 0.95 }}
                                                >
                                                    {pageNumber}
                                                </motion.button>
                                            );
                                        } else if (
                                            (pageNumber === currentPage - 2 && currentPage > 3) ||
                                            (pageNumber === currentPage + 2 && currentPage < totalPages - 2)
                                        ) {
                                            return <span key={index} className="text-muted px-2" style={{ 
                                                color: isDarkMode ? 'var(--color-muted)' : undefined 
                                            }}>...</span>;
                                        }
                                        return null;
                                    })}
                                </div>

                                {currentPage < totalPages && (
                                    <motion.button
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        className="btn btn-outline-primary rounded-pill px-4 py-2"
                                        style={{
                                            background: 'linear-gradient(135deg, #000c3d 0%, #1a237e 100%)',
                                            color: 'white',
                                            border: 'none',
                                            fontWeight: '600'
                                        }}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        {t('departments.next')}
                                        <i className="fas fa-chevron-right ms-2"></i>
                                    </motion.button>
                                )}
                            </div>
                        </motion.div>
                    )}

                </div>


            </div>


        </div>
    </section>

}
export default AllSubDepartments;